// extracted by mini-css-extract-plugin
export var activityContainer = "_mu-0";
export var typingIndicatorContainer = "_mu-1";
export var typingIndicatorDot = "_mu-2";
export var wave = "_mu-3";